import * as React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getOneRosterUserClasses, UserClassRequestState } from "../../../store/OneRoster/OneRosterUserAction";
import SelectInput from "../../misc/SelectInput";
import TableHorizontalPagedToggle from "../../misc/TableHorizontalPagedToggle";
import StatusCode from "../../../util/StatusCode";
import { useTranslation } from "react-i18next";
import * as Helper from '../../../util/Helper';
import * as OneRosterClassStatus from '../../../util/OneRoster/OneRosterClassStatusUtil';
import { RootState } from "../../../store/store";


const OneRosterUserClasses = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    let userClasses = useSelector<RootState, UserClassRequestState>(state => state.onerosterUser.userClasses);
    const [show, setShow] = useState(true);

    useEffect(() => {
        if (userId) {
            getOneRosterUserClasses(userId, {})(dispatch);
        }
    }, [dispatch, userId]);

    const updateFilter = (value: number | boolean | string | undefined, name: string) => {
        const filter = { ...userClasses.filter };
        if (name !== 'page') {
            filter["page"] = 1;
        }
        if (userId) {
            getOneRosterUserClasses(userId, { ...filter, [name]: value })(dispatch);
        }
    }

    const mapUserClasses = () => {
        if (userClasses.code !== StatusCode.COMPLETE) {
            return [];
        }

        return userClasses.data?.values.map(uc => ({
            id: uc.id,
            data: [
                { value: <Link to={`/oneroster/class/${uc.id}/information`}>{uc.title}</Link> },
                { value: Helper.activeText(uc.enrollmentActive) },
                { value: t(`statusTypes.${uc.status}`, { ns: 'oneRoster' }) },
                { value: <Link to={`/oneroster/schoolunit/${uc.schoolId}/information`}>{uc.schoolName}</Link> },
                { value: Helper.formatDate(uc.created), classname: 'nowrap' },
                { value: Helper.formatDate(uc.modified), classname: 'nowrap' },
                { value: Helper.formatDate(uc.inactivated), classname: 'nowrap' },
                { value: Helper.formatDate(uc.archived), classname: 'nowrap' },
            ]
        }));
    }

    const renderUserClasses = () => {
        return (
            <TableHorizontalPagedToggle
                header={[{ value: t('genericTableHeaders.name', { ns: 'common' }) }, { value: t('userClassesTableHeaders.connectionStatus', { ns: 'oneRoster' }) }, { value: t('userClassesTableHeaders.sectionStatus', { ns: 'oneRoster' }) }, { value: t('commonTableHeaders.school', { ns: 'oneRoster' }) }, { value: t('genericTableHeaders.created', { ns: 'common' }) }, { value: t('genericTableHeaders.modified', { ns: 'common' }) }, { value: t('commonTableHeaders.inactivated', { ns: 'oneRoster' }) }, { value: t('commonTableHeaders.archived', { ns: 'oneRoster' }) }]}
                info={mapUserClasses()}
                show={show}
                toggle={() => setShow(!show)}
                onChangePage={(p) => updateFilter(p, 'page')}
                noResultMsg={t('notFound.userClasses', { ns: 'oneRoster' })}
                requestState={userClasses}
            />
        )
    }

    const count = Helper.getTotalCountText(userClasses)
    return (<>
        <div className="header_member_table large select-status">{t('object.oneRoster.section', { ns: 'common', count: 1 })} {count}
            <span className="right">
                <SelectInput
                    items={OneRosterClassStatus.StatusTypes.map(statusType => ({ value: statusType.id, text: `${t('filter.on', { ns: 'common' })} ${t(`statusTypes.${statusType.id}`, { ns: 'oneRoster' })}` }))}
                    onChange={(name, value) => updateFilter(value, name)}
                    name="status"
                    selected={userClasses?.filter?.status}
                    defaultText={t('filter.status', { ns: 'common' })}
                    className='mb-3'
                />
            </span></div>
        {renderUserClasses()}
    </>);
}

export default OneRosterUserClasses;
